var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoUserGreeninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.297 40.297"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.195 34.529a1.574 1.574 0 00-3.082.642 1.645 1.645 0 01-.333 1.379 1.6 1.6 0 01-1.259.6H4.777a1.6 1.6 0 01-1.259-.6 1.644 1.644 0 01-.333-1.379A17.392 17.392 0 0119.731 21.4q.208.008.417.008t.419-.008a17.316 17.316 0 0113.985 7.686 1.574 1.574 0 102.615-1.753 20.475 20.475 0 00-10.61-8.061 10.7 10.7 0 10-12.813 0A20.474 20.474 0 00.1 34.529 4.782 4.782 0 004.777 40.3H35.52a4.782 4.782 0 004.675-5.767zM12.593 10.7a7.556 7.556 0 117.938 7.546h-.763a7.565 7.565 0 01-7.175-7.546z",
    fill: "#00993b"
  })));
}

export default SvgCoUserGreeninline;